export default {
    data() {
        return {
        };
    },
    computed: {
    },
    methods: {
        getIconCheckedBuyerMixin(checkingResult, currentItem) {
            const me = this;
            let buyerStatus = me.getDefineBuyerStatus(checkingResult, currentItem);
            if (buyerStatus == me.$ms.enum.CheckingStatus.Valid) {
                return 'mi-icon-v2-checking-result-green-tick';
            } else if (buyerStatus == me.$ms.enum.CheckingStatus.Invalid) {
                return 'mi-icon-v2-checking-result-red-tick';
            }
            return 'mi-icon-v2-checking-result-load-orange';
        },
    }
};